export default "__VITE_ASSET__DoonbAez__"